<template>
  <div class="chartsBg">
    <div :id="id" class="charts" style="height:350px"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props: {
    id: "",
    chartOption: {}
  },
  watch: {
    chartOption: {
      handler() {
        this.myEcharts();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.myEcharts();
  },
  methods: {
    myEcharts() {
      if (document.getElementById(this.id)) {
        var myChart = echarts.init(document.getElementById(this.id));
        var option = this.chartOption;
        myChart.on("click", params => {
          this.$emit("echartClick", params);
        });
        myChart.setOption(option, true); // 加上true表示不合并配置
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/byCharts/lineChart.vue